import React, {Component} from 'react';
import { browserHistory } from 'react-router';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {getAccessToken} from '../actions';
import {appendMsgToToaster} from '../utils';

class OauthCallback extends Component {

  componentDidMount() {
    const {location, user, getAccessToken, handleDeniedOauthUser} = this.props;
    const {oauth_verifier, oauth_token} = location.query;

    if (oauth_verifier && (oauth_token === user.oauthToken)) {
      getAccessToken(oauth_verifier);
    } else {
      appendMsgToToaster({
        type: 'info',
        message: "You declined to provide access to your MotorsportReg account. You must click Authorize in order to proceed."
      });
      browserHistory.push('/parking');
    }
  }

  render() {
    return <div />;
  }

}

const mapStateToProps = (state) => {
  return {
    user: state.user
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({getAccessToken}, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(OauthCallback);


// WEBPACK FOOTER //
// ./src/containers/OauthCallback.js